import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0.705rem calc(1.25rem + 73px)',
    borderBottom: '1px solid transparent',
    boxSizing: 'border-box',
    fontSize: theme.size.sm,
    transition: 'all 200ms',

    '&:hover': {
      borderBottomColor: '#E984FF'
    },

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      margin: '0.705rem 0'
    }
  },

  activity: {
    color: theme.palette.textLight,

    '& .emphasize': {},

    [theme.breakpoints.down('md')]: {
      textAlign: 'center'
    }
  },

  time: {
    marginLeft: 'auto',
    fontSize: theme.size.sm,

    [theme.breakpoints.down('md')]: {
      marginLeft: 'unset'
    }
  }
}))

export default useStyles
